// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610121635/js/" + chunkId + "." + {"44":"1ea83705","225":"132b16c3","481":"f146f97d","486":"975e350c","770":"8f830da3"}[chunkId] + ".0.4453604487209767.chunk.js";
};